export const ADD_TO_CART_REQUEST = "ADD_TO_CART_REQUEST";
export const ADD_TO_CART_SUCCESS = "ADD_TO_CART_SUCCESS";
export const ADD_TO_CART_FAIL = "ADD_TO_CART_FAIL";

// ---- for remove
export const REMOVE_TO_CART_REQUEST = "REMOVE_TO_CART_REQUEST";
export const REMOVE_TO_CART_SUCCESS = "REMOVE_TO_CART_SUCCESS";
export const REMOVE_TO_CART_FAIL = "REMOVE_TO_CART_FAIL";
